import { render, staticRenderFns } from "./lt-logo.vue?vue&type=template&id=2f2df01f&scoped=true"
var script = {}
import style0 from "./lt-logo.vue?vue&type=style&index=0&id=2f2df01f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@7.1.4_@rspack+core@2.1.1_webpack@5.108.2_postcss@8.5.16___1b790b54f7ec47b93c925242303ba546/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2df01f",
  null
  
)

export default component.exports